import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { HttpService } from "../../service/HttpService";

const handleDownloadPhysicalInventoryExcel = async (
  setShowLoginPopup,
  ids = []
) => {
  const httpService = new HttpService(setShowLoginPopup);

  const fetchPhysicalInventoryData = () => {
    return new Promise((resolve, reject) => {
      const idParam = ids.join(",");

      httpService
        .get(`inventory/physical/byids?ids=${idParam}`)
        .then((response) => {
          if (response?.data) {
            resolve(response?.data);
          } else {
            reject(new Error("No data found"));
          }
        })
        .catch((error) => {
          console.error("Error fetching physical inventory data:", error);
          reject(error);
        });
    });
  };

  try {
    const physicalData = await fetchPhysicalInventoryData();
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Physical Inventory");

    worksheet.addRow([
      "Item Description",
      "Stored Location",
      "Reorder Threshold",
      "Unit",
      "Reorder Amount",
      "On-Hand Quantity",
      "Department",
      "Employee",
      "Date",
    ]);
    worksheet.getRow(1).alignment = { horizontal: "center" };

    if (Array.isArray(physicalData) && physicalData.length > 0) {
      physicalData.forEach((item) => {
        worksheet.addRow([
          item?.item_name || "",
          item?.stored_location || "",
          parseFloat(item?.reorder_threshold) || "",
          item?.unit || "",
          parseFloat(item?.reorder_amount) || "",
          parseFloat(item?.on_hand_qty) || "",
          item?.department_name || "",
          item?.emp_name || "",
          item?.date ? moment(item.date).format("MM/DD/YYYY") : "",
        ]);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const formattedDate = moment().format("MM-DD-YYYY_hh-mm-ss_A");
    saveAs(new Blob([buffer]), `PhysicalInventoryData_${formattedDate}.xlsx`);
  } catch (error) {
    console.error("Error downloading physical inventory Excel:", error);
  }
};

export { handleDownloadPhysicalInventoryExcel };
